const printJS = require('print-js');

var filesQueue = [];

function nextPrint() {
    if (filesQueue.length > 0) {
        let file = filesQueue.pop();
        print(file);
    }
}

function multiPrint(files) {
    if (files && files.length > 0) {
        files.forEach((file, ind, arr) => filesQueue.push(file));
        nextPrint();
    }
}

function print(file) {
    if (canDirectPrint(file.contentType)) {
        let fileType = 'image';
        if (file.contentType === 'application/pdf') {
            fileType = 'pdf';
        }
        printJS({
            printable: file.url,
            type: fileType,
            modalMessage: 'Загрузка документа...',
            showModal: true,
            onPdfOpen: nextPrint,
            onPrintDialogClose: nextPrint,
            onError: nextPrint
        });
    } else {
        window.open('http://docs.google.com/gview?url=' + file.url, '_blank');
        nextPrint();
    }
}

function canDirectPrint(contentType) {
    return contentType === 'application/pdf'
        || contentType === 'image/jpeg'
        || contentType === 'image/png'
        || contentType === 'image/tiff';
}

module.exports = {
    print: print,
    multiPrint: multiPrint
};


// WEBPACK FOOTER //
// ./App/services/print.js